angular.module('omfm', [
	'ngAnimate',
	'ngStorage',
	'ngResource',
	'ngSanitize',
	'templates',
	'ui.bootstrap',
	'ui.sortable',
	'jsonFormatter',
	'ui.loading',
	'ui.message',
	'ui.simpleModal',
	'etCopy',
	'ngCkeditor',
	'ngMask',
	'ui.simplePagination',
	'ui.validationErrorMessage',
	'720kb.datepicker',
	'angularResizable'
]);
